import React from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaChartLine, FaCogs, FaCloud } from 'react-icons/fa';

const highlights = [
  {
    icon: <FaChartLine />,
    title: 'Live Dashboards',
    description: 'Track projects, devices and deliverables in real time from one place.',
  },
  {
    icon: <FaCogs />,
    title: 'Automation Tools',
    description: 'Purpose-built tools that streamline the workflows we design for you.',
  },
  {
    icon: <FaCloud />,
    title: 'Client Portal',
    description: 'Secure, always-on access to your projects, files and support.',
  },
];

const Solutions = () => {
  return (
    <section
      id="solutions"
      className="relative min-h-screen bg-[#0A2F1D] py-20 px-4 flex items-center overflow-hidden"
    >
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[42rem] h-[42rem] bg-accent-green/10 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative z-10 container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-accent-green tracking-[0.3em] text-xs md:text-sm font-semibold uppercase mb-4">
            Beyond The Website
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-6">
            Our <span className="text-accent-green">Solutions</span> Platform
          </h2>
          <p className="text-cream/80 text-lg md:text-xl max-w-3xl mx-auto">
            A dedicated home for the tools, dashboards and portals we build for our
            clients &mdash; separate from this site, and built to work as hard as your
            business does.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-14">
          {highlights.map((h, index) => (
            <motion.div
              key={h.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              className="bg-forest/60 border border-accent-green/20 hover:border-accent-green/50 rounded-lg p-8 transition-all group"
            >
              <div className="text-3xl text-accent-green mb-4 group-hover:scale-110 transform transition-transform">
                {h.icon}
              </div>
              <h3 className="text-xl font-semibold text-cream mb-2">{h.title}</h3>
              <p className="text-cream/70">{h.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex flex-col items-center gap-4"
        >
          <motion.a
            href="https://solutions.platypusbox.com"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            className="inline-flex items-center gap-3 bg-accent-green text-forest font-semibold text-lg px-8 py-4 rounded-md hover:bg-accent-green/90 transition-colors shadow-lg shadow-accent-green/20"
          >
            Visit solutions.platypusbox.com
            <FaExternalLinkAlt className="text-sm" />
          </motion.a>
          <p className="text-cream/50 text-sm">Opens in a new tab</p>
        </motion.div>
      </div>
    </section>
  );
};

export default Solutions;
